import { siteStats } from '@/mocks/51cgHomeData';

export default function HeroSection() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const id = href.replace('#', '');
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center pt-[72px] pb-10 md:pb-14 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-accent-50/50"></div>

      <div className="relative w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-14">

          <div className="w-full lg:w-[55%] flex flex-col items-start">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-4 whitespace-nowrap">
              <i className="ri-fire-line text-sm"></i>
              实时更新 · 全网最快吃瓜
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading text-foreground-950 leading-tight mb-3">
              51cg吃瓜网
              <span className="block text-accent-500 mt-1">全网最全黑料吃瓜第一站</span>
            </h1>

            <p className="text-base md:text-lg text-foreground-700 leading-relaxed mb-5 max-w-[560px]">
              51cg吃瓜网专注收录51cg莫里秀全集、找爹系列视频、51cg爆料内幕与51cg情感八卦内容。每日更新海量51cg黑料合集，覆盖娱乐圈、网红圈及社会热点。51cg.fun黑料吃瓜网品牌矩阵，51cg在线观看持续更新，让你随时随地掌握最新爆料动态。
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-[560px]">
              从明星恋情曝光、网红人设崩塌到综艺幕后揭秘，51cg吃瓜网汇聚全网最热门的51cg黑料话题。站内所有内容均由专业团队与热心网友共同维护，确保每一条51cg爆料都有据可查、有料可看。
            </p>

            <div className="flex flex-wrap items-center gap-5 md:gap-8 mb-7">
              <div className="flex flex-col items-start">
                <span className="text-xl md:text-2xl font-heading text-accent-500">{siteStats.dailyArticles}</span>
                <span className="text-xs md:text-sm text-foreground-500">日均更新文章</span>
              </div>
              <div className="w-px h-8 bg-background-300"></div>
              <div className="flex flex-col items-start">
                <span className="text-xl md:text-2xl font-heading text-accent-500">{siteStats.monthlyViews}</span>
                <span className="text-xs md:text-sm text-foreground-500">月访问量</span>
              </div>
              <div className="w-px h-8 bg-background-300"></div>
              <div className="flex flex-col items-start">
                <span className="text-xl md:text-2xl font-heading text-accent-500">{siteStats.totalVideos}</span>
                <span className="text-xs md:text-sm text-foreground-500">视频资源</span>
              </div>
            </div>

            <div className="flex flex-wrap items-center gap-3">
              <a
                href="#ranking"
                onClick={(e) => handleNavClick(e, '#ranking')}
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-accent-500 text-white rounded-full text-sm font-medium hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line"></i>
                查看热度榜单
              </a>
              <a
                href="#index"
                onClick={(e) => handleNavClick(e, '#index')}
                className="inline-flex items-center gap-2 px-5 py-2.5 border border-background-300 text-foreground-700 rounded-full text-sm font-medium hover:bg-background-100 hover:border-background-400 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-compass-3-line"></i>
                探索专题索引
              </a>
            </div>
          </div>

          <div className="w-full lg:w-[45%] flex-shrink-0">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=A%20dramatic%20and%20vibrant%20editorial%20illustration%20of%20a%20modern%20digital%20media%20and%20gossip%20news%20hub%2C%20featuring%20warm%20coral%20and%20deep%20burgundy%20color%20palette%2C%20with%20floating%20newspaper%20headlines%2C%20magnifying%20glasses%2C%20social%20media%20icons%2C%20and%20abstract%20geometric%20shapes%20arranged%20in%20a%20dynamic%20magazine-style%20composition%2C%20warm%20beige%20background%2C%20energetic%20yet%20sophisticated%20atmosphere%2C%20editorial%20design%20aesthetic&width=800&height=600&seq=51cg-hero-visual&orientation=landscape"
                alt="51cg吃瓜网 - 全网最全黑料吃瓜第一站"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-accent-500/15 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}